import { Form, Input } from "antd";
import React from "react";
import { chestExpansionOptions } from "../../Options/RespiratoryTherapistOptions";
import DeselectableRadioGroup from "../../../../blocks/FormItems/DeselectableRadioGroup";

const ChestExpansion = ({ form }) => {
  return (
    <>
      <DeselectableRadioGroup
        label={"Chest Expansion"}
        name={["chest_expansion", "status"]}
        options={chestExpansionOptions}
        form={form}
      />
      <Form.Item name={["chest_expansion", "comments"]}>
        <Input placeholder="Comments" />
      </Form.Item>
    </>
  );
};

export default ChestExpansion;
